<template>
  <div style="height: 300px;
    overflow-y: auto;
    overflow-x: hidden;">
    <v-timeline align-top dense>
      <v-timeline-item
        v-for="(mov,index) in data"
        :key="index"
        :color="mov.Tipo == 'C'?'red':'green'"
        small
      >
        <v-row class="pt-1">
          <v-col>
            <strong>{{mov.Concepto}}</strong>
            <br/>
            {{mov.Fecha}}
            <div class="caption">
              ${{mov.Cantidad.C}} {{mov.Cantidad.M}}
            </div>
          </v-col>
        </v-row>
      </v-timeline-item>
          <v-btn
            x-small
            class="ml-16"
            color="secondary"
            @click="nextPage()"
            outlined
            dark
          >
            Ver más movimientos
          </v-btn>
    </v-timeline>
  </div>
</template>

<style scoped></style>

<script>

export default {
  name: "TimeLinePagos",
  components: {},
  props: ["data"],
  data() {
    return {
    };
  },
  methods: {
    nextPage(){
      this.$emit('loadPage',true)
    }
  },
  computed: {
  },
  beforeMount: async function () {
  },
  mounted() {
  },
  watch: {},
};
</script>